<div class="modal-overlay" *ngIf="isVisible">
  <div class="schedule-appointment-modal">
    <!-- Modal Header -->
    <div class="modal-header">
      <div class="header-content">
        <h2 class="modal-title">Schedule Appointment</h2>
        <button class="close-button" (click)="onCancelClick()" aria-label="Close">
          <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13 1L1 13M1 1L13 13"
              stroke="#555963"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
      </div>
    </div>

    <!-- Tab Menu -->
    <div class="tab-menu-container">
      <div
        class="scroll-indicator-left"
        *ngIf="showScrollIndicator && isScrolledToEnd"
        (click)="scrollTabs()"
      >
        <div class="scroll-background"></div>
        <div class="scroll-arrow">
          <svg
            width="6"
            height="10"
            viewBox="0 0 6 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M5 1L1 5L5 9"
              stroke="#15172E"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
      </div>
      <div class="tab-menu" #tabMenu (scroll)="onScroll()">
        <div
          class="tab-item"
          [class.active]="currentStep === 1"
          [class.disabled]="!canProceedToStep(1)"
          [class.completed]="isStepCompleted(1)"
          (click)="canProceedToStep(1) ? goToStep(1) : null"
        >
          <div class="tab-content">
            <div class="step-number" *ngIf="!isStepCompleted(1)">1</div>
            <div class="step-checkmark" *ngIf="isStepCompleted(1)">
              <svg
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8.91602 0.948596C9.79584 1.45659 10.5277 2.18557 11.0392 3.06335C11.5508 3.94114 11.8241 4.9373 11.8323 5.95321C11.8406 6.96913 11.5833 7.96957 11.086 8.8555C10.5888 9.74144 9.86874 10.4821 8.99724 11.0043C8.12574 11.5264 7.13298 11.8119 6.11724 11.8325C5.1015 11.853 4.098 11.6079 3.20609 11.1215C2.31418 10.635 1.56477 9.92407 1.03207 9.05898C0.499369 8.19389 0.201838 7.20468 0.168932 6.18926L0.166016 6.00026L0.168932 5.81126C0.201601 4.80384 0.494752 3.82207 1.01981 2.96168C1.54486 2.10128 2.2839 1.39161 3.16487 0.901861C4.04584 0.412112 5.03868 0.158994 6.0466 0.167185C7.05452 0.175375 8.04312 0.444595 8.91602 0.948596ZM8.16177 4.42118C8.06132 4.32074 7.92768 4.26041 7.78591 4.25149C7.64415 4.24258 7.504 4.2857 7.39177 4.37276L7.33693 4.42118L5.41602 6.34151L4.66177 5.58785L4.60693 5.53943C4.49469 5.45243 4.35457 5.40936 4.21283 5.4183C4.0711 5.42724 3.9375 5.48758 3.83709 5.588C3.73667 5.68842 3.67633 5.82202 3.66739 5.96375C3.65845 6.10548 3.70151 6.2456 3.78852 6.35785L3.83693 6.41268L5.0036 7.57935L5.05843 7.62776C5.16073 7.70713 5.28653 7.75021 5.41602 7.75021C5.5455 7.75021 5.6713 7.70713 5.7736 7.62776L5.82843 7.57935L8.16177 5.24601L8.21018 5.19118C8.29725 5.07894 8.34036 4.9388 8.33145 4.79703C8.32254 4.65527 8.2622 4.52163 8.16177 4.42118Z"
                  fill="#717683"
                />
              </svg>
            </div>
            <span class="tab-label">Select Detailing</span>
          </div>
        </div>
        <div
          class="tab-item"
          [class.active]="currentStep === 2"
          [class.disabled]="!canProceedToStep(2)"
          [class.completed]="isStepCompleted(2)"
          (click)="canProceedToStep(2) ? goToStep(2) : null"
        >
          <div class="tab-content">
            <div class="step-number" *ngIf="!isStepCompleted(2)">2</div>
            <div class="step-checkmark" *ngIf="isStepCompleted(2)">
              <svg
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8.91602 0.948596C9.79584 1.45659 10.5277 2.18557 11.0392 3.06335C11.5508 3.94114 11.8241 4.9373 11.8323 5.95321C11.8406 6.96913 11.5833 7.96957 11.086 8.8555C10.5888 9.74144 9.86874 10.4821 8.99724 11.0043C8.12574 11.5264 7.13298 11.8119 6.11724 11.8325C5.1015 11.853 4.098 11.6079 3.20609 11.1215C2.31418 10.635 1.56477 9.92407 1.03207 9.05898C0.499369 8.19389 0.201838 7.20468 0.168932 6.18926L0.166016 6.00026L0.168932 5.81126C0.201601 4.80384 0.494752 3.82207 1.01981 2.96168C1.54486 2.10128 2.2839 1.39161 3.16487 0.901861C4.04584 0.412112 5.03868 0.158994 6.0466 0.167185C7.05452 0.175375 8.04312 0.444595 8.91602 0.948596ZM8.16177 4.42118C8.06132 4.32074 7.92768 4.26041 7.78591 4.25149C7.64415 4.24258 7.504 4.2857 7.39177 4.37276L7.33693 4.42118L5.41602 6.34151L4.66177 5.58785L4.60693 5.53943C4.49469 5.45243 4.35457 5.40936 4.21283 5.4183C4.0711 5.42724 3.9375 5.48758 3.83709 5.588C3.73667 5.68842 3.67633 5.82202 3.66739 5.96375C3.65845 6.10548 3.70151 6.2456 3.78852 6.35785L3.83693 6.41268L5.0036 7.57935L5.05843 7.62776C5.16073 7.70713 5.28653 7.75021 5.41602 7.75021C5.5455 7.75021 5.6713 7.70713 5.7736 7.62776L5.82843 7.57935L8.16177 5.24601L8.21018 5.19118C8.29725 5.07894 8.34036 4.9388 8.33145 4.79703C8.32254 4.65527 8.2622 4.52163 8.16177 4.42118Z"
                  fill="#717683"
                />
              </svg>
            </div>
            <span class="tab-label">Booking Details</span>
          </div>
        </div>
        <div
          class="tab-item"
          [class.active]="currentStep === 3"
          [class.disabled]="!canProceedToStep(3)"
          [class.completed]="isStepCompleted(3)"
          (click)="canProceedToStep(3) ? goToStep(3) : null"
        >
          <div class="tab-content">
            <div class="step-number" *ngIf="!isStepCompleted(3)">3</div>
            <div class="step-checkmark" *ngIf="isStepCompleted(3)">
              <svg
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8.91602 0.948596C9.79584 1.45659 10.5277 2.18557 11.0392 3.06335C11.5508 3.94114 11.8241 4.9373 11.8323 5.95321C11.8406 6.96913 11.5833 7.96957 11.086 8.8555C10.5888 9.74144 9.86874 10.4821 8.99724 11.0043C8.12574 11.5264 7.13298 11.8119 6.11724 11.8325C5.1015 11.853 4.098 11.6079 3.20609 11.1215C2.31418 10.635 1.56477 9.92407 1.03207 9.05898C0.499369 8.19389 0.201838 7.20468 0.168932 6.18926L0.166016 6.00026L0.168932 5.81126C0.201601 4.80384 0.494752 3.82207 1.01981 2.96168C1.54486 2.10128 2.2839 1.39161 3.16487 0.901861C4.04584 0.412112 5.03868 0.158994 6.0466 0.167185C7.05452 0.175375 8.04312 0.444595 8.91602 0.948596ZM8.16177 4.42118C8.06132 4.32074 7.92768 4.26041 7.78591 4.25149C7.64415 4.24258 7.504 4.2857 7.39177 4.37276L7.33693 4.42118L5.41602 6.34151L4.66177 5.58785L4.60693 5.53943C4.49469 5.45243 4.35457 5.40936 4.21283 5.4183C4.0711 5.42724 3.9375 5.48758 3.83709 5.588C3.73667 5.68842 3.67633 5.82202 3.66739 5.96375C3.65845 6.10548 3.70151 6.2456 3.78852 6.35785L3.83693 6.41268L5.0036 7.57935L5.05843 7.62776C5.16073 7.70713 5.28653 7.75021 5.41602 7.75021C5.5455 7.75021 5.6713 7.70713 5.7736 7.62776L5.82843 7.57935L8.16177 5.24601L8.21018 5.19118C8.29725 5.07894 8.34036 4.9388 8.33145 4.79703C8.32254 4.65527 8.2622 4.52163 8.16177 4.42118Z"
                  fill="#717683"
                />
              </svg>
            </div>
            <span class="tab-label">Customer Info</span>
          </div>
        </div>
        <div
          class="tab-item"
          [class.active]="currentStep === 4"
          [class.disabled]="!canProceedToStep(4)"
          [class.completed]="isStepCompleted(4)"
          (click)="canProceedToStep(4) ? goToStep(4) : null"
        >
          <div class="tab-content">
            <div class="step-number" *ngIf="!isStepCompleted(4)">4</div>
            <div class="step-checkmark" *ngIf="isStepCompleted(4)">
              <svg
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8.91602 0.948596C9.79584 1.45659 10.5277 2.18557 11.0392 3.06335C11.5508 3.94114 11.8241 4.9373 11.8323 5.95321C11.8406 6.96913 11.5833 7.96957 11.086 8.8555C10.5888 9.74144 9.86874 10.4821 8.99724 11.0043C8.12574 11.5264 7.13298 11.8119 6.11724 11.8325C5.1015 11.853 4.098 11.6079 3.20609 11.1215C2.31418 10.635 1.56477 9.92407 1.03207 9.05898C0.499369 8.19389 0.201838 7.20468 0.168932 6.18926L0.166016 6.00026L0.168932 5.81126C0.201601 4.80384 0.494752 3.82207 1.01981 2.96168C1.54486 2.10128 2.2839 1.39161 3.16487 0.901861C4.04584 0.412112 5.03868 0.158994 6.0466 0.167185C7.05452 0.175375 8.04312 0.444595 8.91602 0.948596ZM8.16177 4.42118C8.06132 4.32074 7.92768 4.26041 7.78591 4.25149C7.64415 4.24258 7.504 4.2857 7.39177 4.37276L7.33693 4.42118L5.41602 6.34151L4.66177 5.58785L4.60693 5.53943C4.49469 5.45243 4.35457 5.40936 4.21283 5.4183C4.0711 5.42724 3.9375 5.48758 3.83709 5.588C3.73667 5.68842 3.67633 5.82202 3.66739 5.96375C3.65845 6.10548 3.70151 6.2456 3.78852 6.35785L3.83693 6.41268L5.0036 7.57935L5.05843 7.62776C5.16073 7.70713 5.28653 7.75021 5.41602 7.75021C5.5455 7.75021 5.6713 7.70713 5.7736 7.62776L5.82843 7.57935L8.16177 5.24601L8.21018 5.19118C8.29725 5.07894 8.34036 4.9388 8.33145 4.79703C8.32254 4.65527 8.2622 4.52163 8.16177 4.42118Z"
                  fill="#717683"
                />
              </svg>
            </div>
            <span class="tab-label">Vehicle Details</span>
          </div>
        </div>
        <!-- Scroll indicator (right arrow) -->
      </div>
      <div
        class="scroll-indicator"
        *ngIf="showScrollIndicator && !isScrolledToEnd"
        (click)="scrollTabs()"
      >
        <div class="scroll-background"></div>
        <div class="scroll-arrow">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" *ngIf="!isScrolledToEnd">
            <path
              d="M6 4L10 8L6 12"
              stroke="#15172E"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
      </div>
    </div>

    <!-- Modal Content -->
    <div class="modal-content">
      <div class="step-content">
        <!-- Step 1: Select Detailing -->
        <div *ngIf="currentStep === 1" class="step-panel">
          <app-customer-information-form
            titleHeading="Select Detailing"
            (continueStep)="onContinue()"
            (back)="previousStep()"
            [currentStep]="currentStep"
            (cancelFlow)="onCancelClick()"
          >
            <app-package-selection
              [selectedPackageId]="selectedPackageId"
              (packageSelected)="onPackageSelected($event)"
            >
            </app-package-selection>
          </app-customer-information-form>
        </div>

        <!-- Step 2: Booking Details (lazy mount — avoids location/employee API until this step) -->
        <div *ngIf="currentStep === 2" class="step-panel">
          <app-customer-information-form
            #bookingDetailsForm
            titleHeading="Booking Details"
            [requiresValidation]="true"
            [currentStep]="currentStep"
            (continueStep)="onContinue()"
            (back)="previousStep()"
            (cancelFlow)="onCancelClick()"
          >
            <app-appointment-form
              [initialData]="appointmentFormData"
              [packageId]="selectedPackageId"
              (formValidityChange)="bookingDetailsForm.onFormValidityChange($event)"
              (formDataChange)="onAppointmentFormDataChange($event)"
            >
            </app-appointment-form>
          </app-customer-information-form>
        </div>

        <!-- Step 3: Customer Info -->
        <div *ngIf="currentStep === 3" class="step-panel">
          <app-customer-information-form
            #customerInfoForm
            titleHeading="Customer Info"
            [requiresValidation]="true"
            [shouldCreateCustomer]="true"
            [currentStep]="currentStep"
            (continueStep)="onStep3Continue()"
            (back)="previousStep()"
            (cancelFlow)="onCancelClick()"
            (createCustomer)="onCreateCustomer()"
          >
            <app-customer-info
              #customerInfoComponent
              [initialData]="customerFormData"
              (formValidityChange)="customerInfoForm.onFormValidityChange($event)"
              (formDataChange)="onCustomerFormDataChange($event)"
              (customerCreated)="onCustomerCreated($event)"
              (processingStateChange)="customerInfoForm.onProcessingStateChange($event)"
            >
            </app-customer-info>
          </app-customer-information-form>
        </div>

        <!-- Step 4: Vehicle Details -->
        <div *ngIf="currentStep === 4" class="step-panel">
          <app-customer-information-form
            #vehicleDetailsForm
            titleHeading="Vehicle Details"
            [requiresValidation]="true"
            [currentStep]="currentStep"
            [hasExistingVehicles]="vehicleData && vehicleData.length > 0"
            [isAddingNewVehicle]="isAddingNewVehicle"
            [customerId]="getCustomerId()"
            [vehicleCount]="vehicleData ? vehicleData.length : 0"
            (continueStep)="onContinue()"
            (back)="previousStep()"
            (cancelFlow)="onCancelClick()"
            (addNewVehicle)="onAddNewVehicle()"
            (vehicleFormDataChange)="onVehicleFormDataChange($event)"
            (cancelAddVehicle)="onCancelAddVehicle()"
            (saveNewVehicle)="onSaveNewVehicle($event)"
          >
            <!-- Show vehicle edit form when editing -->

            <!-- Vehicle Limit Warning -->
            <div class="vehicle-limit-warning" *ngIf="vehicleData && vehicleData.length >= 5">
              <div class="warning-content">
                <div class="warning-icon">
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="9.99935" cy="10.0003" r="8.33333" fill="#F57600" />
                    <path
                      d="M9.99203 12.5H9.99951"
                      stroke="white"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M10 10L10 6.66667"
                      stroke="white"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
                <div class="warning-text">
                  <div class="warning-title">Vehicle limit reached!</div>
                  <div class="warning-message">
                    You can only add up to 5 vehicles to a family plan. Remove an existing vehicle
                    to add another.
                  </div>
                </div>
              </div>
            </div>
            <!-- Show vehicle selection list when vehicles are fetched and not editing -->
            <div *ngIf="vehicleData && vehicleData.length > 0" class="vehicle-selection-container">
              <!--
                The ControlValueAccessor lives on mat-radio-group, not on the individual
                mat-radio-button, so [(ngModel)] belongs here (NG01203 otherwise).
                The group finds its buttons with descendants: true, so nesting inside
                the *ngFor cards is fine.
              -->
              <mat-radio-group
                class="vehicle-list"
                name="vehicleSelection"
                [(ngModel)]="selectedVehicleIndex"
                (ngModelChange)="onVehicleSelectionChange($event)"
              >
                <div
                  *ngFor="let vehicle of vehicleData; let i = index; trackBy: trackByIndex"
                  class="vehicle-card"
                >
                  <div *ngIf="editingVehicleData?.id !== vehicle.id">
                    <div class="vehicle-header">
                      <div class="vehicle-select">
                        <mat-radio-button [value]="i"></mat-radio-button>
                        <label [for]="'vehicle-' + i" class="vehicle-name"
                          >{{ vehicle.year }} {{ vehicle.make }} {{ vehicle.model }}</label
                        >
                      </div>
                      <!-- Desktop Actions -->
                      <div class="vehicle-actions desktop-actions" *ngIf="!isMobile">
                        <button
                          class="action-btn edit-btn"
                          (click)="editVehicle(vehicle, i)"
                          style="border-bottom: 1px solid #ddd"
                        >
                          <svg
                            width="15"
                            height="15"
                            viewBox="0 0 15 15"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M9.2487 2.41627L12.582 5.7496M1.33203 13.6663H4.66536L13.4154 4.91627C13.6342 4.6974 13.8079 4.43756 13.9263 4.15159C14.0448 3.86563 14.1057 3.55913 14.1057 3.2496C14.1057 2.94007 14.0448 2.63357 13.9263 2.34761C13.8079 2.06164 13.6342 1.8018 13.4154 1.58293C13.1965 1.36406 12.9367 1.19045 12.6507 1.072C12.3647 0.953545 12.0582 0.892578 11.7487 0.892578C11.4392 0.892578 11.1327 0.953545 10.8467 1.072C10.5607 1.19045 10.3009 1.36406 10.082 1.58293L1.33203 10.3329V13.6663Z"
                              stroke="#326FD1"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </button>
                        <button class="action-btn delete-btn" (click)="deleteVehicle(vehicle, i)">
                          <svg
                            width="16"
                            height="18"
                            viewBox="0 0 16 18"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M1.33203 4.83333H14.6654M6.33203 8.16667V13.1667M9.66536 8.16667V13.1667M2.16536 4.83333L2.9987 14.8333C2.9987 15.2754 3.17429 15.6993 3.48685 16.0118C3.79941 16.3244 4.22334 16.5 4.66536 16.5H11.332C11.7741 16.5 12.198 16.3244 12.5105 16.0118C12.8231 15.6993 12.9987 15.2754 12.9987 14.8333L13.832 4.83333M5.4987 4.83333V2.33333C5.4987 2.11232 5.5865 1.90036 5.74278 1.74408C5.89906 1.5878 6.11102 1.5 6.33203 1.5H9.66536C9.88638 1.5 10.0983 1.5878 10.2546 1.74408C10.4109 1.90036 10.4987 2.11232 10.4987 2.33333V4.83333"
                              stroke="#D9342B"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </button>
                      </div>

                      <!-- Mobile Dropdown -->
                      <div class="mobile-dropdown-container" *ngIf="isMobile">
                        <button class="mobile-dropdown-trigger" (click)="toggleDropdown(i)">
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M4 12C4 12.2652 4.10536 12.5196 4.29289 12.7071C4.48043 12.8946 4.73478 13 5 13C5.26522 13 5.51957 12.8946 5.70711 12.7071C5.89464 12.5196 6 12.2652 6 12C6 11.7348 5.89464 11.4804 5.70711 11.2929C5.51957 11.1054 5.26522 11 5 11C4.73478 11 4.48043 11.1054 4.29289 11.2929C4.10536 11.4804 4 11.7348 4 12ZM11 12C11 12.2652 11.1054 12.5196 11.2929 12.7071C11.4804 12.8946 11.7348 13 12 13C12.2652 13 12.5196 12.8946 12.7071 12.7071C12.8946 12.5196 13 12.2652 13 12C13 11.7348 12.8946 11.4804 12.7071 11.2929C12.5196 11.1054 12.2652 11 12 11C11.7348 11 11.4804 11.1054 11.2929 11.2929C11.1054 11.4804 11 11.7348 11 12ZM18 12C18 12.2652 18.1054 12.5196 18.2929 12.7071C18.4804 12.8946 18.7348 13 19 13C19.2652 13 19.5196 12.8946 19.7071 12.7071C19.8946 12.5196 20 12.2652 20 12C20 11.7348 19.8946 11.4804 19.7071 11.2929C19.5196 11.1054 19.2652 11 19 11C18.7348 11 18.4804 11.1054 18.2929 11.2929C18.1054 11.4804 18 11.7348 18 12Z"
                              stroke="#555963"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </button>

                        <!-- Dropdown Menu -->
                        <div class="mobile-dropdown-menu" *ngIf="openDropdownIndex === i">
                          <button
                            class="dropdown-item edit-item"
                            (click)="onDropdownAction('edit', vehicle, i)"
                          >
                            <span>Edit</span>
                            <svg
                              width="14"
                              height="14"
                              viewBox="0 0 14 14"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M4.08398 4.0834H3.50065C3.19123 4.0834 2.89449 4.20631 2.67569 4.4251C2.4569 4.6439 2.33398 4.94064 2.33398 5.25006V10.5001C2.33398 10.8095 2.4569 11.1062 2.67569 11.325C2.89449 11.5438 3.19123 11.6667 3.50065 11.6667H8.75065C9.06007 11.6667 9.35682 11.5438 9.57561 11.325C9.7944 11.1062 9.91732 10.8095 9.91732 10.5001V9.91673M9.33398 2.91673L11.084 4.66673M11.8919 3.84131C12.1216 3.61157 12.2507 3.29997 12.2507 2.97506C12.2507 2.65016 12.1216 2.33856 11.8919 2.10881C11.6622 1.87907 11.3506 1.75 11.0257 1.75C10.7007 1.75 10.3891 1.87907 10.1594 2.10881L5.25065 7.00006V8.75006H7.00065L11.8919 3.84131Z"
                                stroke="#555963"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </svg>
                          </button>
                          <button
                            class="dropdown-item delete-item"
                            (click)="onDropdownAction('delete', vehicle, i)"
                          >
                            <span>Delete</span>
                            <svg
                              width="14"
                              height="14"
                              viewBox="0 0 14 14"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M2.33398 4.08333H11.6673M5.83398 6.41667V9.91667M8.16732 6.41667V9.91667M2.91732 4.08333L3.50065 11.0833C3.50065 11.3928 3.62357 11.6895 3.84236 11.9083C4.06115 12.1271 4.3579 12.25 4.66732 12.25H9.33398C9.6434 12.25 9.94015 12.1271 10.1589 11.9083C10.3777 11.6895 10.5007 11.3928 10.5007 11.0833L11.084 4.08333M5.25065 4.08333V2.33333C5.25065 2.17862 5.31211 2.03025 5.42151 1.92085C5.5309 1.81146 5.67927 1.75 5.83398 1.75H8.16732C8.32203 1.75 8.4704 1.81146 8.5798 1.92085C8.68919 2.03025 8.75065 2.17862 8.75065 2.33333V4.08333"
                                stroke="#555963"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </svg>
                          </button>
                        </div>
                      </div>
                    </div>
                    <div class="vehicle-details">
                      <div class="detail-row">
                        <div class="detail-item">
                          <span class="detail-label">LICENSE PLATE</span>
                          <span class="detail-value">{{
                            vehicle.license_plate || vehicle.licensePlate || 'N/A'
                          }}</span>
                        </div>
                        <div class="detail-item">
                          <span class="detail-label">VIN</span>
                          <span class="detail-value">{{ vehicle.vin || 'N/A' }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <app-vehicle-list
                    *ngIf="
                      isEditingVehicle &&
                      editingVehicleData &&
                      editingVehicleData?.id === vehicle.id
                    "
                    #vehicleEditComponent
                    [isEditMode]="true"
                    [editVehicleData]="editingVehicleData"
                    [customerId]="getCustomerId()"
                    (cancelEdit)="onCancelEdit()"
                    (saveEdit)="onSaveEdit($event)"
                  >
                  </app-vehicle-list>
                </div>
              </mat-radio-group>
            </div>

            <!-- Show vehicle input form when no vehicles are fetched and not editing -->
            <app-vehicle-list
              *ngIf="
                (!vehicleData || vehicleData.length === 0) &&
                !isEditingVehicle &&
                !isAddingNewVehicle
              "
              #vehicleListComponent
              [initialData]="vehicleFormData"
              [customerId]="getCustomerId()"
              (formValidityChange)="vehicleDetailsForm.onFormValidityChange($event)"
              (formDataChange)="onVehicleFormDataChange($event)"
              (vehicleCreatedManually)="onVehicleCreatedManually($event)"
              [showSaveCancelButtons]="false"
            >
            </app-vehicle-list>
          </app-customer-information-form>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Discard create appointment confirmation -->
<app-discard-changes-modal
  [isOpen]="showCloseConfirmationModal"
  (cancel)="onCloseConfirmationCancel()"
  (confirm)="onCloseConfirmationConfirm()"
>
</app-discard-changes-modal>

<!-- Delete Vehicle Alert Modal -->
<app-delete-vehicle-alert-modal
  [isOpen]="showDeleteModal"
  (cancel)="onDeleteModalClose()"
  (confirm)="onDeleteModalConfirm(vehicleToDelete)"
>
</app-delete-vehicle-alert-modal>

<!-- Success Modal -->
<app-success-modal
  [isVisible]="showSuccessModal"
  title="Appointment Confirmed!"
  description="The car detailing appointment for the customer is scheduled successfully."
  buttonText="Go to Appointment Details"
  [vehicleMake]="successVehicleMake"
  [vehicleModel]="successVehicleModel"
  [vehicleYear]="successVehicleYear"
  (close)="onSuccessModalClose()"
  (primaryAction)="onSuccessModalAction()"
>
</app-success-modal>

<!-- Appointment Details Modal -->
<app-appointment-details-modal
  [isVisible]="showAppointmentDetailsModal"
  [appointment]="selectedAppointmentForDetails"
  (close)="onAppointmentDetailsModalClose()"
  (appointmentUpdated)="onAppointmentUpdated()"
  (markCompleteAppointment)="onMarkCompleteFromDetailsModal($event)"
  (rescheduleAppointment)="onRescheduleFromDetailsModal($event)"
  (cancelAppointment)="onCancelFromDetailsModal($event)"
>
</app-appointment-details-modal>

<!-- Cancel Appointment Confirmation Modal -->
<app-cancel-appointment-modal
  [isVisible]="isCancelModalVisible"
  [appointment]="appointmentToCancel"
  (confirm)="onCancelConfirm($event)"
  (cancel)="onCancelModalClose()"
  (close)="onCancelModalClose()"
>
</app-cancel-appointment-modal>

<!-- Cancellation Reason Modal -->
<app-cancellation-reason-modal
  [isVisible]="isCancellationReasonModalVisible"
  [item]="appointmentToCancel"
  (submit)="onCancelReasonSubmit($event)"
  (close)="onCancellationReasonModalClose()"
>
</app-cancellation-reason-modal>

<!-- Cancellation Success Modal -->
<app-cancellation-success-modal
  [isVisible]="isCancellationSuccessModalVisible"
  (okay)="onCancellationSuccessModalOkay()"
  (createAnother)="onCancellationSuccessModalCreateAnother()"
  (close)="onCancellationSuccessModalClose()"
>
</app-cancellation-success-modal>

<!-- Cancellation Error Modal -->
<app-cancellation-error-modal
  [isVisible]="isCancellationErrorModalVisible"
  (okay)="onCancellationErrorModalOkay()"
  (close)="onCancellationErrorModalClose()"
>
</app-cancellation-error-modal>

<!-- Reschedule Appointment Modal -->
<app-reschedule-appointment-modal
  [isVisible]="isRescheduleModalVisible"
  [appointment]="appointmentToReschedule"
  [loading]="isRescheduleLoading"
  (closeModal)="onRescheduleModalClose()"
  (updateAppointment)="onRescheduleUpdate($event)"
>
</app-reschedule-appointment-modal>

<!-- Mark Complete Confirmation Modal -->
<app-mark-complete-modal
  [isVisible]="isMarkCompleteModalVisible"
  [appointment]="appointmentToMarkComplete"
  (confirm)="onMarkCompleteConfirm($event)"
  (cancel)="onMarkCompleteModalClose()"
  (close)="onMarkCompleteModalClose()"
>
</app-mark-complete-modal>
